import React from "react";
import styled from "styled-components";
import GatsbyImage, { FixedObject } from "gatsby-image";

export interface HowItWorksStepProps {
  position: number;
  title: string;
  description: string;
  fixed: FixedObject;
}

export function HowItWorksStep({
  position,
  title,
  description,
  fixed,
}: HowItWorksStepProps) {
  return (
    <ColumnContainer>
      <GatsbyImage fixed={fixed} />
      <TitleContainer>
        <Position>{position}</Position>
        <Title>{title}</Title>
      </TitleContainer>
      <Description>{description}</Description>
    </ColumnContainer>
  );
}

const ColumnContainer = styled.div`
  flex-direction: column;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 321px;
`;

const TitleContainer = styled.div`
  margin-top: ${(props) => props.theme.spacing.sm};
  flex-direction: row;
  display: flex;
  width: 100%;
  align-items: flex-start;
`;

const Position = styled.div`
  color: ${(props) => props.theme.color.subduedText};
  font-size: ${(props) => props.theme.typography.typeScale[300]};
  border-radius: 999px;
  border: 1px solid ${(props) => props.theme.color.subduedText};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  line-height: 25px;
  height: 25px;
  flex-basis: 25px;
  flex-shrink: 0;
  font-weight: ${(props) => props.theme.typography.weight.regular};
  margin-right: ${(props) => props.theme.spacing.sm};
  margin-top: 3px;
`;

const Title = styled.div`
  font-size: ${(props) => props.theme.typography.typeScale[300]};
  font-weight: ${(props) => props.theme.typography.weight.regular};
`;

const Description = styled.div`
  font-size: ${(props) => props.theme.typography.typeScale[100]};
  font-weight: ${(props) => props.theme.typography.weight.regular};
  text-align: left;
  width: 100%;
  color: ${(props) => props.theme.color.textLabelValue};
`;
